// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__15heX","index":"styles_index__1hC6b"};